import React from 'react' ;
import { Link } from 'react-router-dom';

const Head = () => {
    return(
        <div className="head" >
            <h3>Make Food Make Fun ..  </h3>
            {

            }
            {/* <div className="bookmarkTab" > */}
                {/* <Link to='/' >BookMarked Recipe</Link> */}
            {/* </div> */}
        </div>
    );
}

export default Head;